import { MuiF } from '../../../../Mui/F/Function/module/MuiF.js';
import { OMPSizeGaugeMuiF } from '../Mui/module/OMPSizeGaugeMuiF.js';
import { OMPCoreUtilF } from '../../../../OMP/Core/Util/F/Function/module/OMPCoreUtilF.js';
import { ChangeSizeRangeEvent, SizeGauge } from '@modules/NewMaker/UI/sizeGauge/SizeGauge.ts';
import { rune } from 'rune-ts';
import { getBaseProductInMaker, getProductColorInMaker } from '@modules/Maker/F/getSth.js';
import { find, go } from 'fxjs/es';
import { $find, $qs, $trigger } from 'fxdom/es';
import { processAfterSelect } from '@modules/BpOption/F/Function/bpoption.js';
import { FlexiAPI } from '@modules/NewMaker/FlexiMaker/F/Function/flexiAPI.js';
import { OFFSET_BP_OPTION_GROUP } from '@modules/NewMaker/FlexiMaker/S/Constant/fleximaker.js';
import { SVGEditorUtilF } from '@modules/SVGEditor/Util/F/Function/module/SVGEditorUtilF.js';
import { ButtonCTA, CTAButtonEvent } from '@modules/NewMaker/UI/ButtonCTA/ButtonsCTA.ts';
import { errorHandling } from '@modules/BpOption/F/Function/event.js';

const offsetData = () => {
  const base_product = getBaseProductInMaker();
  const bp_option_groups = go(
    base_product._.base_products_bp_option_groups,
    find(({ bp_option_group_id }) => bp_option_group_id == OFFSET_BP_OPTION_GROUP.bp_option_group_id),
  );

  if (!bp_option_groups) return {};

  return {
    offset_options: {
      default_bp_option_id: bp_option_groups?.default_bp_option_id,
      option_name: bp_option_groups._.bp_option_group['name' + G._en],
      bp_options: bp_option_groups._.bp_option_group._.bp_options,
    },
    selected_offset_option_id: FlexiAPI.getBpOptionIdByOffset(G.mp.maker.flexiMaker.offsetDistance),
  };
};
export const openSizeGauge = async (data) => {
  return await MuiF.openFrame(OMPSizeGaugeMuiF.frame, async (f, p, [t]) => {
    f.always_remove = true;
    f.hide_frame_button_type = 'V';
    f.is_modal = false;
    f.height = G.mp.maker?.flexiMaker?.isPlush || G.mp.maker?.flexiMaker?.isTtibu ? 232 : 272;
    f.header_height = 30;
    p.title = TT('product::list::list_3_1');
    f.prev_frame_show = true;
    f.animation = true;
    f.appended = $.frame_close_bg;
    f.showing = () => {
      G.mp.maker.ban_frame_show();
      G.mp.maker.zoom.by_active1(G.mp.maker.active(), 272 + G.mp.frame.v_height);
    };
    f.closing = async () => {
      G.mp.maker.ban_frame_hide();
      FlexiAPI.setSizeGuide();
      G.mp.maker.zoom.recover();
    };
    f.appended = (frame_el) => {
      SVGEditorUtilF.halfFrameClose(frame_el);
    };

    t.makeData = () => ({
      ...data,
      ...offsetData(),
    });

    t.appended = (tab_el) => {
      OMPCoreUtilF.hydrationRune(SizeGauge, ButtonCTA);
      FlexiAPI.setSizeGuide();

      const size_gauge_el = tab_el.querySelector('.SizeGauge');
      if (size_gauge_el) {
        const sizeGauge = rune.getView(size_gauge_el, SizeGauge);
        sizeGauge.addEventListener(ChangeSizeRangeEvent, async (e) => {
          const product = getProductColorInMaker();
          const canvas_zoom_wrapper = document.querySelector('.canvas_zoom_wrapper');

          const real_size = await FlexiAPI.updateSize(product, canvas_zoom_wrapper, e.detail);
          if (!real_size) return;

          sizeGauge.updateDOM(real_size);
          if (e.detail.is_valid === false) {
            sizeGauge.showSizeAdjustedToast();
          }
        });
      }

      const button_cta_els = tab_el.querySelectorAll('.ButtonCTA');
      const buttonCtas = [];

      button_cta_els.forEach((button_cta_el) => {
        const buttonCta = rune.getView(button_cta_el, ButtonCTA);
        buttonCtas.push(buttonCta);
        buttonCta.addEventListener(CTAButtonEvent, (e) => {
          buttonCtas.forEach((btn) => {
            btn.setSelect(false);
          });

          buttonCta.setSelect(true);

          const target_option = document.querySelector(
            `.bp_option_group[data-id="${OFFSET_BP_OPTION_GROUP.bp_option_group_id}"] .select_box .option[data-id="${e.detail.id}"]`,
          );
          $trigger('click', target_option);
        });
      });
    };
    f.closed = async () => {
      const bp_option_group_el = go($qs('.bp_option_group[data-ui_type_pc="FLEXI"]'), $find('select'));
      await errorHandling(async () => {
        await processAfterSelect(bp_option_group_el);
      });
      FlexiAPI.setSizeGuide();
    };
  });
};
